
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { isOptionalGoodsPackage, ShopGoodsInfoDto} from "@/api/shoppingMall";
import {GoodsInfoDto} from "@/api/commodity"
import {
  getGoodsSpecificationList,
  GetPreOrderInfoParamsDto,
  PackageListDto,
  RuleListDto,
  SelectSKUListDto
} from "@/api/buyCar";
import {isContained} from "@/components/PackageSelector/packageSelector";
import {Action, Getter} from "vuex-class";
import { goodsDetailDto, goodsPackageDto } from '@/api/goods';
import { downloadUrl, handleFill } from '@/utils/util';
import { assemble, getIntersection } from '@/utils/assemble'

@Component({
  components: {
    coomdsPrice: () => import('@/views/goodsManage/commodity/subPage/coomdsPrice.vue'),
    coomdsPrices: () => import('@/views/goodsManage/commodity/subPage/coomdsPrices.vue')
  }
})
export default class PackageSelector extends Vue {
  @Getter providerId!: string // 店铺编号
  @Getter companyId!: string
  @Action setPreOrderParams!: (val: GetPreOrderInfoParamsDto) => void;
  @Prop({ default: {} }) detailInfo?: goodsPackageDto

  downloadUrl = downloadUrl
  handleFill = handleFill

  showRules = false
  labelWidth = 120

  ruleType = '3' // ’1‘加入购物车  ’2‘立即下单  ’3‘选择规格可加购可下单,默认值3 '4'购物车选择规格后确定
  // 商品规格列表
  ruleList: RuleListDto[] = []
  // 后端返回的套餐列表
  packageList: PackageListDto[] = []
  // 套餐列表信息
  skuList: PackageListDto[] = []
  currentSkuList: string[][] = []
  /*  将sku规格值的ID，即 packageId，组成一个数组并且字典排序，以及将该sku所对应的index存入数组，供点击后查询sku */
  valueIdSortAndIndex: { valueIdSort: string[] }[] = []

  selectItemList: SelectSKUListDto[] = [] // 用于设置规格是否为禁用状态
  selectValue = '' // 已选规格code拼接字符串，用于对应套餐列表中packageName
  selectValueList: string[] = [] // 已选规格code的数组形式，必须已ruleList列表的顺序作为相应下标
  mainImageUrl = '' // 商品主图
  weight = '' // 商品重量
  brandId='' //商品编码
  goodsId = '' // 商品id
  goodsName = '' // 商品名称
  goodsPrice:number | string = '' // 商品单价
  marketPriceMax:number | string =''
  referPriceMax:number | string =''
  selectPackageInfo: PackageListDto = {}
  goodsInfo: any = {}

  disabledAttrValue: string[] = []
  selectGoodsSpec: string[] = []
  currGoodsPackage: goodsPackageDto & { iscombo?: boolean } = {
    cusLevelPriceList: [],
    cusPriceList: [],
    iscombo: true
  }

  @Watch('currGoodsPackage',  { deep: true })
  onCurrGoodsPackage () {
    this.$emit('on-currGoodsPackage', this.currGoodsPackage)
  }
  @Watch('detailInfo', { deep: true, immediate: true })
  onDetailInfo () {
    this.goodsInfo = this.detailInfo
    // this.initSelectGoodsSpec()
    console.log(this.goodsInfo)

  }

  get cusLevelPriceList () {
    return this.currGoodsPackage.cusLevelPriceList && this.currGoodsPackage.cusLevelPriceList.length
  }
  get cusPriceList () {
    return this.currGoodsPackage.cusPriceList && this.currGoodsPackage.cusPriceList.length
  }

  handleCoomdsPrice () {
    if (!this.cusLevelPriceList) {
      return false
    }
    (this.$refs.coomdsPrice as any).showModal({
      data: JSON.parse(JSON.stringify(this.currGoodsPackage.cusLevelPriceList)),
      marketPrice: this.currGoodsPackage.marketPrice,
      type: 'detail'
    })
  }
  handleCustomerPrice () {
    if (!this.cusPriceList) {
      return false
    }
    (this.$refs.coomdsPrices as any).showModal({
      data: JSON.parse(JSON.stringify(this.currGoodsPackage.cusPriceList)),
      marketPrice: this.currGoodsPackage.marketPrice,
      isUseCusPrice: this.currGoodsPackage.isUseCusPrice,
      type: 'detail'
    })
  }

  closeRules () {
    this.showRules = false
  }

  /**
   * ruleType 规格弹窗类型
   * goodsInfo 商品详情信息
   * selectList 已选择规格数据
   * */
  show(data: {  goodsInfo?: GoodsInfoDto, selectList?: string[] }) {
    this.showRules = true
    this.goodsInfo = data.goodsInfo
    this.initSelectGoodsSpec()
  }

  handleSelectGoodsSpec (index: number, e: any) {
    let selectGoodsSpecString = ''
    const value = typeof e === 'string' ? e : e.target.value
    // 取消选中
    if (this.selectGoodsSpec.includes(value)) {
      this.selectGoodsSpec.splice(index, 1, undefined)
    } else {
      this.$set(this.selectGoodsSpec, index, value)
    }
    selectGoodsSpecString = this.selectGoodsSpec.join(',')
    console.log(selectGoodsSpecString)

    if (this.disabledAttrValue.includes(value)) return false

    if (this.goodsInfo.goodsSpecificationList!.length > 1) {
      this.disabledAttrValue = []
    }
    let valid = this.setDisabledAttrValue(value)
    // if (!valid) return false

    this.currGoodsPackage = {}
    this.goodsInfo.goodsPackageList!.some(item => {
      if (item.packageName === selectGoodsSpecString) {
        this.currGoodsPackage = { ...item, iscombo: true }
      } else {
        // this.currGoodsPackage = { ...item, iscombo: false }
      }
      return item.packageName === selectGoodsSpecString
    })
  }
  setDisabledAttrValue (value: string) {
    const matchDownGoodsPackage = this.getAllMatchGoodsPackage(value, this.selectGoodsSpec)
    if (matchDownGoodsPackage.length) {
      this.goodsInfo.goodsSpecificationList!.forEach(item => {
        item.specValueList!.forEach(specValue => {
          // specValue.disabled = matchDownGoodsPackage.includes(specValue.attrValueCode as string) && (this.selectGoodsSpec.includes(value) ? specValue.attrValueCode !== value : !!1)
          specValue.disabled = matchDownGoodsPackage.includes(specValue.attrValueCode as string) && !this.selectGoodsSpec.includes(specValue.attrValueCode as string)
          if (specValue.disabled) {
            this.disabledAttrValue.push(specValue.attrValueCode as string)
          }
        })
      })
      return false
    }
    return true
  }
  getAllMatchGoodsPackage (value: string, selectGoodsSpec: string[]): string[] {
    const sepcListLen = this.goodsInfo.goodsSpecificationList!.length
    if (this.selectGoodsSpec.length < sepcListLen - 1) return []
    const matchDownGoodsPackage = this.getMatchDownGoodsPackage(sepcListLen === 1 ? [[value]] : assemble(selectGoodsSpec.map(i => [i]), sepcListLen - 1 || 1))
    return matchDownGoodsPackage
  }
  /**
   * 获取所有下架商品套餐
   */
  getAllDownGoodsPackage (): string[] {
    return (
      this.goodsInfo.goodsPackageList!.map(item => {
        if (item.packageStatus !== 1) {
          // @ts-ignore
          console.log(item.packageNameDesc)
          return item.packageName
        }
      }).filter(Boolean) as []
    )
  }

    /**
     * 商品套餐信息按客户级别定价界面原生返回功能调用
     */
    handlPriceAppCancel(){
        (this.$refs.coomdsPrice as any).handleBack();
    }

    /**
     * 商品套餐信息按客户定价界面原生返回功能调用
     */
    handlPricesAppCancel(){
        (this.$refs.coomdsPrices as any).handleBack()
    }

  getMatchDownGoodsPackage (data: Array<string[]>): string [] {
    const allDownGoodsPackage = this.getAllDownGoodsPackage()
    let intersection: string[] = []
    let packages: Array<string[]> = []
    data.forEach(item => {
      allDownGoodsPackage.forEach(packageName => {
        intersection = getIntersection(item, packageName.split(','))
        if (!intersection.length) return false
        if (intersection.join(',') === item.join(',')) {
          packages.push(packageName.split(','))
        }
      })
    })
    return [].concat.apply([], packages as [])
  }
  initSelectGoodsSpec () {
    this.selectGoodsSpec = []
    // @ts-ignore
    if (!(this.goodsInfo.isMultiSpec || this.goodsInfo.multiSpec)) {
      this.currGoodsPackage = { ...this.goodsInfo.goodsPackageList![0] || {}, iscombo: true }
    } else {
      const allSpecs: Array<string[]> = []
      this.goodsInfo.goodsSpecificationList!.forEach((item, index: number) => {
        // if (item.specValueList && item.specValueList!.length) {
        // this.handleSelectGoodsSpec(index, (item.specValueList![0] as any).attrValueCode)
        // }
        item.specValueList!.forEach(specValue => {
          if (allSpecs[index]) {
            allSpecs[index].push(specValue.attrValueCode as string)
          } else {
            allSpecs[index] = [specValue.attrValueCode as string]
          }
        })
        if (this.goodsInfo.goodsSpecificationList!.length === 1) {
          item.specValueList!.forEach(specValue => {
            this.setDisabledAttrValue(specValue.attrValueCode as string)
          })
        }
      })
      const allDownGoodsPackage = this.getAllDownGoodsPackage()
      const assembleData: Array<string[]> = assemble(allSpecs, allSpecs.length)
      assembleData.some((item, index) => {
        const valid = !allDownGoodsPackage.includes(item.join(','))
        if (valid) {
          item.forEach((attrValueCode, attrValueIndex: number) => {
            this.handleSelectGoodsSpec(attrValueIndex, attrValueCode)
          })
        }
        return valid
      })
    }
  }
}
